export enum AppraiseStageType {
    Order = 0,
    Receive = 1,
    Review = 2,
}
